import { BraveBupAPI } from '@BUP/services/Axios';
import { firebaseDeleteCurrentUser } from '@BUP/services/Firebase';
import {
  COMMENT_OPEN,
  COMMENT_CLOSED 
} from '@BUP/constants';

export const getUserByFirebaseID = async (firebaseUser) => {
  const { uid } = firebaseUser;
  if (!uid) return null;
  try {
    const response = await BraveBupAPI.get(`/users/${uid}/firebase`);
    const data = Object.keys(response.data).length ? response?.data : null;
    return formatUserSchema(data);
  } catch (e) {
    console.log("getUserByFirebaseID error", e)
    throw { code: 'auth/signin-braveup-user', message: 'Ocurrio un error al iniciar sesíon, por favor vuelve a intentarlo.' }
  }
}

export const createUserWhitOutInvitationCode = async (firebaseUser) => {
  const { uid, displayName, email } = firebaseUser;
  if (!uid) return null;
  try {
    const response = await BraveBupAPI.post('/users', {
      name: displayName,
      email: email,
      id_firebase: uid,
      organizationId: null,
      rolId: null,
      courseId: null
    })
    return response.data;
  } catch (e) {
    console.log("createUserWhitOutInvitationCode error", e);
    firebaseDeleteCurrentUser();
    throw { 
      code: 'auth/create-braveup-user', 
      title: 'ERROR AL CREAR CUENTA',
      message: 'Ocurrio un error al registrar el usuario, por favor vuelve a intentarlo.' 
    }
  }
}

export const createUserByInvitationCode = async (firebaseUser, name, code) => {
  const { uid, email } = firebaseUser;
  try {
    const response = await BraveBupAPI.post('/users', {
      name: name,
      email: email,
      id_firebase: uid,
      invitationId: code
    })
    return response.data;
  } catch (e) {
    console.log("createUserByInvitationCode error", e);
    firebaseDeleteCurrentUser();
    throw { 
      code: 'auth/create-braveup-user-whit-code', 
      title: 'ERROR AL CREAR CUENTA',
      message: 'Ocurrio un error al registrar el usuario, por favor vuelve a intentarlo.' 
    }
  }

}

export const getBraveUpUserById = async (userId) => {
  try {
    const response = await BraveBupAPI.get(`/users/${userId}`);
    return formatUserSchema(response.data);
  } catch (e) {
    throw { code: 'auth/signin-braveup', message: 'Problemas al iniciar sesión, vuelve a intentarlo.' }
  }
}

export const formatUserSchema = (user) => {
  const formatUser = {
    id: user?.id,
    name: user?.name,
    email: user?.email,
    active: user?.active,
    id_firebase: user?.id_firebase,
    courseId: user?.enrollments[0]?.courseId || null,
    courses: user?.enrollments[0]?.courses || null,
    organizations: user?.enrollments[0]?.organizations || null,
    roles: user?.enrollments[0]?.roles || null,
    enrollmentId: user?.enrollments[0]?.id || null
  }
  return user ? formatUser : null;
}

export const isModeBup = (user) => {
  const { organizations } = user;
  return organizations && organizations?.mode_bup ? true : false
}

export const hasOrganization = (user) => {
  return user && user?.organizations ? true : false
}

export const getMessageCreatorInfo = (message) => {
  const enrollment = message?.enrollment;
  const isAnonymous = message?.anonymus === true ? true : false;
  const course = enrollment?.courses?.name;
  const name = enrollment?.users?.name;
  const role = enrollment?.roles;
  const roleName = role?.name;
  const roleType = role?.type;
  const messageCreator = `${isAnonymous ?
    'Anónimo' : name ? name : 'Sin Nombre'} - ${roleName ? roleName : 'Sin Rol'} - ${course ? course : 'Sin Curso'}`;
  return { messageCreator }
}

export const isModeBupCaseOpen = (comment) => {
  const caseState = comment?.state;
  if(!caseState) return false;
  return caseState === COMMENT_OPEN ? 
        true : caseState == COMMENT_CLOSED ?
        false : true
}

export const isRoleAllowed = (userRole, roles) => {
  return roles && roles.length ? 
    roles.includes(userRole) ? true : false
  : false
}